<template>
  <div>
    <div class="wrapper-content">
      <v-row>
        <v-col>
          <div id="odontogramaFull" class="svg-container"></div>
          <div id="tooltipId" class="tooltipDiv">
            <span id="tooltipSpan"></span>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import odontogramaFull from "@/json/odontograma_full.json";
import svg from "svg.js/dist/svg";

export default {
  name: "Odontograma",
  props: {
    model: Object,
    treatment: {},
    dentalTreatment: {},
    searchTreatmentsByTooth: Function,
  },
  data: () => ({
    dentalTreatmentOdon: {
      id: "",
      mapId: "",
      zone: "",
      zoneName: "",
      area: "",
      selectTreatments: [],
    },
    mapId: "",
    zone: "",
    zoneName: "",
    area: "",
    selectTreatments: [],
    svgMap: "",
    svgContainer: "",
    svgEditContainer: "",
    pathMap: "",
    arrPath: [],
    arrPathSelect: [],
  }),
  mounted() {
    this.generateMap();
  },

  methods: {
    /*ODONTOGRAMA BASE */
    generateMap() {
      const svgOdontoContainer = svg("odontogramaFull").viewbox(
        0,
        0,
        3200,
        1700
      );
      odontogramaFull.forEach((pathObj) => {
        this.generatePath(svgOdontoContainer, pathObj);
      });
    },
    generatePath(svgCont, pathObj, changeColorForUpdate) {
      const attrs = {
        stroke: "#000",
        "stroke-width": 4,
        title: pathObj["@name"],
        "map-id": pathObj["@id"],
        zone: pathObj["@zone"],
        zoneName: pathObj["@zoneName"],
        area: pathObj["@area"],
        fill: changeColorForUpdate ? "black" : "white",
        transform: pathObj["@transform"] ? pathObj["@transform"] : null,
      };
      const dental = svgCont.path(pathObj["@d"]).attr(attrs);
      this.svgMap = dental;
      this.svgContainer = svgCont;
      if (pathObj["@area"] != undefined) {
        dental.mouseover((element) => {
          if (
            element.target.attributes.transform == undefined ||
            element.target.attributes.transform == null
          ) {
            const zoneName = element.target.attributes.zoneName.value;
            const id = element.target.attributes["map-id"].value;
            let tooltip = document.getElementById("tooltipId");
            let span = document.getElementById("tooltipSpan");
            span.innerHTML = `Pieza: ${id} | ${zoneName}`;

            tooltip.style.top = element.layerY + 575 + "px";
            tooltip.style.left = element.layerX + "px";
          }
        });

        dental.click((item) => {
          if (
            item.target.attributes.transform == undefined ||
            item.target.attributes.transform == null
          ) {
            this.dentalTreatmentOdon.id = item.target.attributes.d.value;
            this.dentalTreatmentOdon.mapId =
              item.target.attributes["map-id"].value;
            this.dentalTreatmentOdon.zoneName =
              item.target.attributes.zoneName.value;
            this.dentalTreatmentOdon.zone = item.target.attributes.zone.value;
            this.dentalTreatmentOdon.area = item.target.attributes.area.value;
            this.svgMap = dental;
            this.pathMap = pathObj;
            this.svgContainer = svgCont;
          }
          // console.log(this.dentalTreatmentOdon.id);
          this.$emit("OpenDialog", this.dentalTreatmentOdon);
          this.arrPathSelect.push(pathObj);
          this.dentalTreatmentOdon = {};
        });
        this.svgEditContainer = svgCont;
        this.arrPath.push(pathObj);
      }
    },
    paintSelectSVG: function(value, obj) {
      this.dentalTreatmentOdon.selectTreatments = this.dentalTreatment.selectTreatments;
      if (value > 0) {
        this.svgMap.attr({
          fill: "black",
        });
        this.$emit("OpenDialog", this.dentalTreatmentOdon);
      } else if (value == 0) {
        const path = this.arrPath;
        for (const u in path) {
          if (path[u]["@d"] == obj.id) {
            const attrs = {
              fill: "white",
              stroke: "#000",
              "stroke-width": 4,
            };
            for (const pathObj in this.arrPathSelect) {
              if (this.arrPathSelect[pathObj]["@d"] == obj.id) {
                return this.generatePath(
                  this.svgContainer,
                  this.arrPathSelect[pathObj]
                );
              }
            }
            return this.svgContainer.path(path[u]["@d"]).attr(attrs);
          }
        }
      } else if (value == "editar") {
        const path = this.arrPath;
        for (const u in path) {
          if (path[u]["@d"] == obj.id) {
            const attrs = {
              fill: "black",
            };
            let paintItBlack = true;
            this.generatePath(this.svgContainer, path[u], paintItBlack);
            // this.svgContainer.path(path[u]["@d"]).attr(attrs);
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
.tooltipDiv {
  height: 25px;
  border-color: rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  border-width: thin;
  border-style: solid;
  background-color: rgba(0, 0, 0, 0.7);
  color: rgba(255, 255, 255);
  position: absolute;
  // display: none;
}

.tooltipDiv span {
  margin: 10px;
}

.svg-container {
  width: 100%;
  position: relative;
  path {
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    &:hover {
      fill: #689f38;
    }
  }
}
</style>
